import React from 'react';
import { get } from 'helpers/utilities';
import Icon from 'components/Icon';
import CarouselVideo from 'components/CarouselVideo';

import { getHeaderMedia } from 'queries/pageHeaderMedia';
import useBreakpoint from '../../hooks/useBreakpoint';

import styles from './styles.scss';

const imageSizes = {
  largeDesktop: 2000,
  smallDesktop: 1440,
  tablet: 1248,
  mobile: 960
};

const LocationHeader = ({ headerTitle, officeLocation, ...rest }) => {
  const {
    addressLine1,
    addressLine2,
    city,
    state,
    zip,
    phoneNumber,
    emailAddress,
    mapUrl = ''
  } = get(officeLocation, '[0]', {});
  const breakpoint = useBreakpoint();
  return (
    <header className={styles.locationHeader}>
      <section className={styles.locationHeader__container}>
        <h1
          className={styles.locationHeader__title}
          dangerouslySetInnerHTML={{ __html: headerTitle }}
        />
        <div className={styles.locationHeader__details}>
          <address className={styles.locationHeader__address}>
            <a
              href={mapUrl}
              title={headerTitle}
              className={styles.locationHeader__address__link}
              target="_blank"
              rel="noopener noreferrer">
              {headerTitle}
            </a>
            <Icon name="location" classes={styles.locationHeader__address__icon} />
            <span className={styles.locationHeader__address__address1}>{addressLine1}</span>
            <span className={styles.locationHeader__address__address1}>{addressLine2}</span>
            <span className={styles.locationHeader__city}>
              {city}, {state} {zip}
            </span>
          </address>
          <span className={styles.locationHeader__phone}>{phoneNumber}</span>
          <span className={styles.locationHeader__email}>{emailAddress}</span>
        </div>
      </section>
      <div className={styles.locationHeader__background}>
        <CarouselVideo
          {...getHeaderMedia(rest, breakpoint)}
          imageClass={styles.locationHeader__background__image}
          grayscale={true}
          imageSizes={imageSizes}
        />
      </div>
    </header>
  );
};

export default LocationHeader;
